<template>
    <div class="siteHeader-in">
        <nav class="breadcrumbs" style="margin-bottom: 20px; margin-top: -20px;">
            <router-link :to="{ name: 'cad.download'}" class="breadcrumbs-item">
                Všechny výkresy
            </router-link>
            <template v-for="category in categoryData">
                <span class="breadcrumbs-sep">›</span>
                <router-link :to="{name: routeName(), params: {slug: category.extendedSlug}}" class="breadcrumbs-item">
                    {{category.name}}
                </router-link>
            </template>
        </nav>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import isUndefined from 'lodash/isUndefined';
    import {SLUG_SEPARATOR} from './const';
    import filter from 'lodash/filter';

    export default {
        name:     'Breadcrumb',
        watch:    {
            '$route': function () {
                this.rerender();
            },
        },
        mounted() {
            this.rerender();
        },
        computed: {
            ...mapGetters('cad', ['categories', 'type']),
        },
        data() {
            return {
                categoryData: [],
            }
        },
        methods:  {
            getSlug() {
                return this.$route.params.slug;
            },
            getOpenedCategories() {
                const slug = this.getSlug()
                if (isUndefined(slug)) return [];
                return slug.split(SLUG_SEPARATOR);
            },
            getCategoryBySlug(slug) {
                const categories = filter(this.categories, category => category.slug === slug);
                if (categories.length) {
                    return categories[0];
                }
                return null;
            },
            rerender() {
                const openedCategories = this.getOpenedCategories();
                this.categoryData = openedCategories.map((categorySlug) => this.getCategoryBySlug(categorySlug));
            },
            routeName() {
              return 'cad.category';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/cad/Breadcrumb.vue